import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
const AuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('session_token');
    if (!token) { setUser(null); setLoading(false); return; }
    try {
      const res = await fetch(`${API}/auth/me`, { headers: { 'Authorization': `Bearer ${token}` } });
      if (!res.ok) throw new Error();
      setUser(await res.json());
    } catch { setUser(null); localStorage.removeItem('session_token'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = (userData) => {
    if (userData.session_token) localStorage.setItem('session_token', userData.session_token);
    setUser(userData);
  };

  const logout = async () => {
    const token = localStorage.getItem('session_token');
    try { await fetch(`${API}/auth/logout`, { method: 'POST', headers: token ? { 'Authorization': `Bearer ${token}` } : {} }); } catch {}
    localStorage.removeItem('session_token');
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};
